import { twMerge } from 'tailwind-merge';

function cx(...classes: (string | undefined)[]): string {
  return twMerge(classes.filter(Boolean));
}

export { cx };
